import ENGLISH_RULES from './englishRules';
import SPANISH_RULES from './spanishRules';

const RULES = {
    english: ENGLISH_RULES,
    spanish: SPANISH_RULES
};

export default RULES;



// WEBPACK FOOTER //
// ./src/components/rules/rules_lists/rules.js